import React, { Fragment, useEffect, useContext } from "react";
import { Portal, useDisclosure } from "@chakra-ui/react";
import { Box, ThemeProvider, Typography, Grid, Container } from "@mui/material";
import { Outlet, Link } from "react-router-dom";
import theme from "../assets/themes/theme";
import Navbar from "./Navbar";
import dashRoutes from "../models/general/routes";
import { EnumConfiguracion } from "./Enumerables.js";
import { account } from "./Utils";
import { useNavigate } from "react-router-dom";
import Alerts from "./Alerts";
import { observer } from "mobx-react-lite";
import LogisticBackdropStore from "../shared/LogisticBackdrop";
import { RootStoreContext } from "../app/store/root";
import { EmbarqueStore } from "../app/store/embarque.js";
import Embarque from "../app/api/embarque/embarque";

// ESTILOS PARA EL BOTON DE AYUDA
const fabStyle = {
  position: "fixed",
  bottom: 16,
  right: 16,
  color: "white",
  fontSize: "1.3rem",
};

const Layout = (props) => {

  const rootStore = useContext(RootStoreContext);

  const {
    setCerrarSesionPorInactividad
  } = rootStore.authStore

  const {
    embarqueActual,
    desbloquearEmbarque,
  } = rootStore.embarqueStore

  const { ...rest } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  var tiempoInactividad = 0;

  const [permisosUsuario, setPermisosUsuario] = React.useState([])

  useEffect(() => {
    if (account.getDatosUsuario() == null) cerrarSesion()
    setPermisosUsuario(account.getPermisosUsuario())
  }, [])

  const cerrarSesion = () => {
    account.removeToken()
    account.removeDatosUsuario()
    navigate("/");
  }

  // OBTENER LA RUTA ACTUAL
  const getActiveRoute = (dashRoutes) => {
    let optionsUsers = dashRoutes.filter(a => permisosUsuario.filter(a => a.esMenu && a.tienePermiso).map(a => { return a.clavePermiso }).includes(a.clave))
    let activeRoute = "";
    for (let i = 0; i < optionsUsers.length; i++) {
      if (
        window.location.href.indexOf(
          optionsUsers[i].layout + optionsUsers[i].path
        ) !== -1
      ) {
        return optionsUsers[i].name;
      }
    }
    return activeRoute;
  };

  // OBTENER TODAS LAS RUTAS DEPENDIENDO SI ES USUARIO O PROVEEDOR, FALTAN VALIDACIONES DE ACUERDO AL TIPO DE USUARIO
  const getRoutes = (dashRoutes) => {
    let optionsUsers = dashRoutes.filter(a => permisosUsuario.filter(a => a.esMenu && a.tienePermiso).map(a => { return a.clavePermiso }).includes(a.clave))
    return optionsUsers
  }

  //const [tiempoInactividad, setTiempoInactividad] = React.useState(0);
  useEffect(() => {
    consultarParametro(EnumConfiguracion.Tiempo_Inactividad);
  }, []);

  const consultarParametro = (claveParametro) => {
    fetch(
      `${process.env.REACT_APP_API_LOGISTICA}/api/Configuracion/ConsultarParametro/${claveParametro}`,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${account.getToken()}`,
        },
      }
    ).then((response) => response.json()).then((response) => {
      if (response.success) {
        tiempoInactividad = parseInt(response.data.valor);
        if (tiempoInactividad > 0) inactivityTime();
      }
    });
  };

  const inactivityTime = () => {
    var time;
    resetTimer();
    document.onmousemove = resetTimer;
    document.onkeypress = resetTimer;

    // console.log("Antes Reset");
    function resetTimer() {
      clearTimeout(time)
      if (tiempoInactividad > 0){
        var maxTime = tiempoInactividad * 60000;
        // console.log("Dentro Timer Reset");
        // console.log("Maxtime" +maxTime);
        // console.log("T.Inact" +tiempoInactividad);

        time = setTimeout(logout, maxTime);
      }
        
    }

    async function logout() {

      
      if (account.getDatosUsuario() != null && tiempoInactividad > 0) {

        var UltEmbarque =  localStorage.getItem("LastEmbarque")
        if(UltEmbarque){
          var result = await Embarque.desbloquearEmbarque(UltEmbarque);
          
           Promise.resolve(result);
        }
        account.removeUltEmbarque()
        account.removeToken()
        account.removeDatosUsuario()


        // if(embarqueActual){
        //   desbloquearEmbarque(embarqueActual.idEmbarque)
        // }
        setCerrarSesionPorInactividad(true)
        setTimeout(() => navigate("/"), 1000);
      }

      // if (account.getDatosUsuario() != null && tiempoInactividad > 0) {
      //   account.removeToken()
      //   account.removeDatosUsuario()
      //   setCerrarSesionPorInactividad(true)
      //   setTimeout(() => navigate("/"), 1000);
      // }
    }
  };

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <Alerts />
        <LogisticBackdropStore /> 
        <Box minHeight={"95vh"}>
          <Box height={"10vh"} width={"100%"} />
          <Portal>
            <Navbar
              onOpen={onOpen}
              brandText={getActiveRoute(dashRoutes)}
              fixed={true}
              routes={getRoutes(dashRoutes)}
              {...rest}
            />
          </Portal>
          <Container >
            <Outlet />
          </Container>
        </Box>
        <footer
          style={{
            color: "gray",
            width: "100%",
            height: "5vh",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Box
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            justifyContent={"center"}
          >
            <a href="https://www.axsistec.com/web/Index.html">
              <Typography
                color="textSecondary"
                component="p"
                variant="caption"
                gutterBottom={false}
              
              >
                Powered by Axsis Tecnología © 2023.
              </Typography>
            </a>
          </Box>
        </footer>
      </ThemeProvider>
    </Fragment>
  );
};

export default observer(Layout);
